"use strict";
exports.__esModule = true;
exports.block = {
    display: 'block'
};
exports.none = {
    display: 'none'
};
exports.inlineBlock = {
    display: 'inline-block'
};
exports.invisible = {
    visibility: 'hidden'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/csstips/lib/display.js
// module id = 308
// module chunks = 0